<div class="complaint-after complaint-after__container d-flex align-items-center">
  <span class="complaint-after__text" style="font-size: 2rem"
        [innerHTML]="translationService.getTranslation('after_complaint')"> </span>
</div>
